// Lightweight analytics layer — supports GA4 (gtag) + PostHog.
// Both providers are optional: enabled only if their env keys are present.
// Auto-tracks any click on elements carrying `data-cta` attribute.

const GA4_ID = process.env.REACT_APP_GA4_ID || "";
const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || "";
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

let initialized = false;

function loadScript(src, async = true) {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) return resolve();
        const s = document.createElement("script");
        s.src = src;
        s.async = async;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
    });
}

function initGA4() {
    if (!GA4_ID) return;
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA4_ID, { send_page_view: true });
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`).catch(() => {});
}

function initPostHog() {
    if (!POSTHOG_KEY) return;
    // Minimal PostHog snippet (no SDK install needed for simple capture)
    !function (t, e) {
        let o, n, p, r;
        e.__SV || (window.posthog = e, e._i = [], e.init = function (i, s, a) {
            function g(t, e) {
                const o = e.split(".");
                2 == o.length && (t = t[o[0]], e = o[1]);
                t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); };
            }
            (p = t.createElement("script")).type = "text/javascript",
                p.async = !0, p.src = s.api_host + "/static/array.js",
                (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
            const u = e;
            for (a = "init capture identify alias group page track".split(" "), n = 0; n < a.length; n++) g(u, a[n]);
            e._i.push([i, s, "posthog"]);
        }, e.__SV = 1);
    }(document, window.posthog || []);
    window.posthog.init(POSTHOG_KEY, { api_host: POSTHOG_HOST, capture_pageview: true });
}

export function trackEvent(name, props = {}) {
    if (!name) return;
    if (window.gtag && GA4_ID) {
        try { window.gtag("event", name, props); }
        catch (err) {
            if (process.env.NODE_ENV !== "production") console.warn("[analytics] gtag failed", err);
        }
    }
    if (window.posthog && POSTHOG_KEY) {
        try { window.posthog.capture(name, props); }
        catch (err) {
            if (process.env.NODE_ENV !== "production") console.warn("[analytics] posthog failed", err);
        }
    }
    // Always log to console in development for visibility
    if (process.env.NODE_ENV !== "production") {
        console.log(`[analytics] ${name}`, props);
    }
}

function hookAutoCtaTracking() {
    document.addEventListener("click", (e) => {
        const target = e.target instanceof Element ? e.target.closest("[data-cta]") : null;
        if (!target) return;
        const name = target.getAttribute("data-cta");
        const props = {
            href: target.getAttribute("href") || undefined,
            label: target.textContent?.trim().slice(0, 80),
            testid: target.getAttribute("data-testid") || undefined,
            section: target.closest("section")?.id || undefined,
        };
        trackEvent(name, props);
    }, { capture: true, passive: true });
}

export function initAnalytics() {
    if (initialized) return;
    initialized = true;
    initGA4();
    initPostHog();
    hookAutoCtaTracking();
}
